import React, { Component } from 'react';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import {
	FormGroup,
	FormFeedback,
	Input,
	Button,
	Modal,
	ModalBody,
	ModalHeader,
	ModalFooter,
	Col,
	Row,
	Container,
} from 'reactstrap';
import { Formik, Form } from 'formik';

import { PrettyCheckboxFormik } from '../Common/PrettyCheckboxFormik';
import { Validations } from '../Common/Validations';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import './Feedback.scss';

import { getVal } from '../../BaseFunctions';

class Feedback extends Component {
	constructor(props) {
		super(props);

		this.state = { isOpen: false };

		this.initialValues = {
			strNomeUsuario: '',
			strEmailUsuario: '',
			strMensagem: '',
			blOpcional: false,
		};

		//#region Esquema de validação do formulário
		const { Yup } = Validations;
		this.validationSchema = Yup.object().shape({
			strMensagem: Yup.string()
				.nullable()
				.max(5000)
				.required(),
			strNomeUsuario: Yup.lazy(() =>
				getVal(this.formik, 'current.state.values.blOpcional')
					? Yup.string()
							.nullable()
							.max(150)
							.required()
					: Yup.string()
							.nullable()
							.max(150),
			),
			strEmailUsuario: Yup.lazy(() =>
				getVal(this.formik, 'current.state.values.blOpcional')
					? Yup.string()
							.nullable()
							.max(100)
							.email()
							.required()
					: Yup.string()
							.nullable()
							.max(100)
							.email(),
			),
		});
		//#endregion Esquema de validação do formulário

		this.formik = React.createRef();
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	handleSubmit = () => {
		this.onLoading(true);
		HttpUtil.eco_POST(`${Config.urls.API_URL_BASE}Feedback/Salvar`, getVal(this.formik, 'current.state.values'))
			.then(() => {
				this.onLoading(false);
				this.showSuccessMessage('Feedback enviado com sucesso!');
			})
			.catch(() => {
				this.onLoading(false);
				this.holdAlerts(true);
				this.showErrorMessage('Não foi possível enviar seu feedback.');
			});
	};

	render() {
		return (
			<Modal id="modalFeedback" toggle={this.closeModal} isOpen={this.state.isOpen} backdrop="static">
				<AlertasContext.Consumer>
					{alertas => {
						this.showInfoMessage = alertas.info;
						this.showSuccessMessage = alertas.success;
						this.showWarningMessage = alertas.warning;
						this.showErrorMessage = alertas.error;
						this.holdAlerts = alertas.setHoldState;
					}}
				</AlertasContext.Consumer>
				<BlockUiContext.Consumer>
					{blockUi => {
						this.onLoading = blockUi.handleLoading;
					}}
				</BlockUiContext.Consumer>
				<Formik
					ref={this.formik}
					initialValues={this.initialValues}
					validationSchema={this.validationSchema}
					validateOnChange={false}
					onSubmit={this.handleSubmit}>
					{formikProps => {
						const { values, errors, touched, handleBlur, handleChange } = formikProps;

						return (
							<Form>
								<ModalHeader>Sua opinião é muito importante!</ModalHeader>
								<ModalBody>
									<Container>
										<Row>
											<Col>
												<p>
													Ajude-nos a melhorar cada vez mais e realizar alterações relevantes
													para facilitar o seu dia a dia no uso dessa ferramenta. Escreva
													abaixo o seu comentário!
												</p>
											</Col>
										</Row>
										<Row>
											<Col>
												<FormGroup row>
													<Col>
														<Input
															type="textarea"
															name="strMensagem"
															onBlur={handleBlur}
															onChange={handleChange}
															rows="5"
															maxLength="5000"
															placeholder="Digite aqui a sua sugestão"
															invalid={
																touched.strMensagem &&
																errors.strMensagem &&
																errors.strMensagem.length > 0
															}
														/>
													</Col>
												</FormGroup>
												<FormGroup row>
													<Col xs="auto" className="ml-auto">
														<PrettyCheckboxFormik
															simpleSelection
															iconSuccess="fas fa-check"
															id="blOpcional"
															labelDefault="Desejo incluir meus dados ao enviar o feedback"
															{...formikProps}
														/>
													</Col>
												</FormGroup>
												{values.blOpcional && (
													<FormGroup row>
														<Col className="col-sm-6 col">
															<Input
																type="text"
																value={values.strNomeUsuario}
																onBlur={handleBlur}
																onChange={handleChange}
																id="strNomeUsuario"
																className="form-control"
																maxLength="150"
																placeholder="Nome"
																invalid={
																	touched.strNomeUsuario &&
																	errors.strNomeUsuario &&
																	errors.strNomeUsuario.length > 0
																}
															/>
															<FormFeedback>Digite seu nome</FormFeedback>
														</Col>
														<Col className="col-sm-6 col">
															<Input
																type="email"
																value={values.strEmailUsuario}
																onBlur={handleBlur}
																onChange={handleChange}
																id="strEmailUsuario"
																className="form-control"
																maxLength="100"
																placeholder="E-mail"
																pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
																invalid={
																	touched.strEmailUsuario &&
																	errors.strEmailUsuario &&
																	errors.strEmailUsuario.length > 0
																}
															/>
															<FormFeedback>Digite seu e-mail</FormFeedback>
														</Col>
													</FormGroup>
												)}
											</Col>
										</Row>
									</Container>
								</ModalBody>
								<ModalFooter>
									<Container>
										<Row className="justify-content-end">
											<Col xs="3">
												<Button color="info" onClick={this.closeModal} block>
													Fechar
												</Button>
											</Col>
											<Col xs="3">
												<Button block color="primary" type="submit">
													Enviar
												</Button>
											</Col>
										</Row>
									</Container>
								</ModalFooter>
							</Form>
						);
					}}
				</Formik>
			</Modal>
		);
	}
}

export default Feedback;
